<template>
  <registration-layout
    ref="form"
  >
    <form
      class="new-registration vue"
      @submit.prevent="submit"
    >
      <h2>Cadastro</h2>

      <brazil-text-field
        v-model="full_name"
        name="name"
        input-id="user_full_name"
        label="Nome Completo"
        autocomplete="name"
        :validator-field="$v.full_name"
      />

      <brazil-text-field
        v-model="date_of_birth"
        name="bday"
        input-id="user_date_of_birth"
        type="tel"
        label="Data de Nascimento"
        autocomplete="bday"
        placeholder="dd/mm/aaaa"
        :mask="dateMask"
        maxlength="10"
        :validator-field="$v.date_of_birth"
      />

      <brazil-text-field
        v-model="email"
        name="email"
        input-id="user_email"
        type="email"
        label="E-mail"
        autocomplete="email"
        :validator-field="$v.email"
      />

      <brazil-text-field
        v-model="email_confirmation"
        name="email_confirmation"
        input-id="user_email_confirmation"
        type="email"
        label="Confirmar E-mail"
        autocomplete="email"
        :validator-field="$v.email_confirmation"
      />

      <brazil-text-field
        v-model="cpf"
        name="cpf"
        input-id="user_cpf"
        type="tel"
        label="CPF"
        autocomplete="cpf"
        placeholder="___.___.___-__"
        :mask="cpfMask"
        maxlength="14"
        :validator-field="$v.cpf"
      />

      <brazil-text-field
        v-model="main_phone"
        name="tel"
        input-id="user_main_phone"
        type="tel"
        label="Telefone celular"
        autocomplete="tel"
        placeholder="(__) ____-____"
        maxlength="15"
        :mask="phoneMask"
        :validator-field="$v.main_phone"
      />

      <brazil-text-field
        v-model="password"
        name="password"
        input-id="user_password"
        type="password"
        label="Senha"
        :validator-field="$v.password"
      >
        <span slot="note">Min. de 7 caracteres</span>
      </brazil-text-field>

      <brazil-text-field
        v-model="password_confirmation"
        name="password_confirmation"
        input-id="user_password_confirmation"
        type="password"
        label="Confirmar Senha"
        :validator-field="$v.password_confirmation"
      />

      <div class="form-group">
        <div class="panel-body unpadded confirmations">
          <brazil-checkbox-field
            name="whatsapp_consent"
            input-id="user_whatsapp_consent"
            :label="getWhatsappConsentLabel()"
            true-value="1"
            false-value="0"
            :validator-field="$v.whatsapp_consent"
            :checked="false"
          />
          <!-- eslint-disable max-len -->
          <brazil-checkbox-field
            name="promotions"
            input-id="wants_electronic_promotions"
            label="Envie-me ofertas especiais e promoções por e-mail ou SMS"
            true-value="1"
            false-value="0"
            :validator-field="$v.wants_electronic_promotions"
            :checked="true"
          />
          <!-- eslint-disable max-len -->
          <input
            id="user_privacy_policy_text"
            name="privacy_policy_text"
            type="hidden"
            value="Li, compreendi e concordo com a <a href=&quot;/politica_de_privacidade&quot; target=&quot;_blank&quot;>Política de Privacidade e a Política de Segurança</a>, bem como a consultar quaisquer informações a meu respeito nos sistemas dos serviços de informações e proteção ao crédito e no Sistema de Informações de Crédito – SCR – do Banco Central do Brasil."
          >
          <brazil-checkbox-field
            name="privacy_policy"
            class="privacy-policy"
            input-id="user_privacy_policy"
            label="Li, compreendi e concordo com a <a href=&quot;/politica_de_privacidade&quot; target=&quot;_blank&quot;>Política de Privacidade e a Política de Segurança</a>, bem como a consultar quaisquer informações a meu respeito nos sistemas dos serviços de informações e proteção ao crédito e no Sistema de Informações de Crédito – SCR – do Banco Central do Brasil."
            true-value="1"
            false-value="0"
            :validator-field="$v.privacy_policy"
          />
          <input
            id="user_positive_credit_data_consent_text"
            name="positive_credit_data_consent_text"
            type="hidden"
            value="Eu autorizo a LH1010 e a LH1003 (Simplic) a acessar os meus dados de histórico financeiro em base de dados conforme a Lei nº 12.414 de 9 de junho de 2011, nos termos da autorização <a id='positive-credit-data-consent-modal-toggle'>deste link</a>"
          >
          <brazil-checkbox-field
            name="positive_credit_data_consent"
            input-id="user_positive_credit_data_consent"
            true-value="1"
            false-value="0"
            :validator-field="$v.positive_credit_data_consent"
            label-class="positive-credit-data-consent"
            wrapper-class="positive_credit_data_consent_wrapper"
            :checked="false"
          >
            <template v-slot:label>
              Eu autorizo a LH1010 e a LH1003 (Simplic) a acessar os meus dados de histórico financeiro em base de dados conforme a Lei nº 12.414 de 9 de junho de 2011, nos termos da autorização <a
                id="positive-credit-data-consent-modal-toggle"
                @click="openPositiveCreditDataConsentModal()"
              >deste link</a>
            </template>
          </brazil-checkbox-field>
          <!-- eslint-enable max-len -->
        </div>
      </div>
      <div class="registration-field">
        <div class="form-group">
          * Preenchimento obrigatório
        </div>
      </div>

      <RegistrationNextButton ref="submitButton" />
    </form>
    <RequirementsSection />
    <positive-credit-data-consent-modal
      v-if="showPositiveCreditDataConsentModal"
      :show-dialog="showPositiveCreditDataConsentModal"
      @closeModal="closePositiveCreditDataConsentModal"
    />
  </registration-layout>
</template>

<script>
import { sync, get, call } from 'vuex-pathify';
import {
  required, email, sameAs,
} from 'vuelidate/lib/validators';
import {
  cpf,
  internationalDate,
  minimumAge,
  moreThanOneWord,
  passwordLength,
  phoneNumberLength,
  positiveCreditDataAgreed,
  privacyPolicyAgreed,
} from '../validators';
import BrazilTextField from '../components/fields/BrazilTextField.vue';
import BrazilCheckboxField from '../components/fields/BrazilCheckboxField.vue';
import PositiveCreditDataConsentModal from '../components/PositiveCreditDataConsentModal.vue';
import RegistrationNextButton from '../components/RegistrationNextButton.vue';
import RequirementsSection from '../components/RequirementsSection.vue';
import RegistrationLayout from '../layouts/RegistrationLayout.vue';
import { cpfMask, dateMask, phoneMask } from '../config/masks';
import { trackEvent } from '../lib/optimizely';
import captureRenderBlockingException from '../tracking/helpers/captureRenderBlockingException';
import trackFormCompletedEvent from '../lib/analytics/trackHelpers/trackFormCompletedEvent';
import { trackMaxScrollDepth } from '../lib/analytics/trackHelpers/trackScrollDepth';
import {
  addAllBehaviorTrackingListeners,
  removeAllBehaviorTrackingListeners,
} from '../lib/analytics/trackHelpers/eventListeners';
import analytics from '../lib/analytics';

export default {
  components: {
    RegistrationLayout,
    RegistrationNextButton,
    RequirementsSection,
    BrazilTextField,
    BrazilCheckboxField,
    PositiveCreditDataConsentModal,
  },
  data() {
    return {
      dateMask,
      cpfMask,
      phoneMask,
      whatsappConsentAutoChecked:         false,
      showPositiveCreditDataConsentModal: false,
      startTime:                          new Date().toISOString(),
      /* eslint-disable global-require */
      whatsappIcon:                       require('../../../assets/images/whats_app_icon.png'),
      /* eslint-enable global-require */
    };
  },
  computed: {
    ...sync('registration', [
      'reg1@full_name',
      'reg1@email',
      'reg1@email_confirmation',
      'reg1@date_of_birth',
      'reg1@cpf',
      'reg1@main_phone',
      'reg1@password',
      'reg1@password_confirmation',
      'reg1@wants_electronic_promotions',
      'reg1@privacy_policy',
      'reg1@privacy_policy_text',
      'reg1@whatsapp_consent',
      'reg1@whatsapp_consent_text',
      'reg1@positive_credit_data_consent',
      'reg1@positive_credit_data_consent_text',
      'reg1@recaptcha_token',
    ]),
    ...get(['backendErrors', 'backendErrorMessages']),
    hasValidMainPhone() {
      return this.$v.main_phone.$invalid === false;
    },
    visitorId() {
      return this.$store.get('rails_session_id');
    },
  },
  watch: {
    main_phone(newValue) {
      if (newValue) {
        if (this.hasValidMainPhone && !this.whatsappConsentAutoChecked) {
          this.whatsappConsentAutoChecked = true;
          this.$store.set('registration/reg1@whatsapp_consent', '1');
        }
      }
    },
  },
  mounted() {
    try {
      trackEvent('reg1_visited', this.visitorId);
      this.$store.dispatch('registration/setCurrentStepNumber', 1);
      if (this.backendErrorMessages) {
        this.flash(this.backendErrorMessages, 'error');
      }
      analytics.page();
      addAllBehaviorTrackingListeners();
    } catch (e) {
      this.$store.dispatch('setBackendErrorMessage');
      this.flash(this.backendErrorMessages, 'error');
      captureRenderBlockingException(e);
    }
  },
  destroyed() {
    removeAllBehaviorTrackingListeners();
  },
  methods: {
    submitReg1: call('registration/submitReg1'),
    async submit() {
      if (this.$v.$invalid || this.$v.$pending) {
        this.$v.$touch();
        this.$refs.submitButton.shakeDisableButton();
        this.$refs.form.focusFirstError();
      } else {
        this.flash().destroyAll();
        try {
          if (typeof grecaptcha !== 'undefined') {
            await this.validateCaptcha();
          }
          await this.submitReg1();
          if (this.backendErrors) {
            this.flash(this.backendErrorMessages.join('<br>'), 'error');
          } else {
            trackFormCompletedEvent('reg1', this.startTime);
            trackMaxScrollDepth('reg1');
            this.$router.push('pessoal');
          }
        } catch (error) {
          this.flash(this.backendErrorMessages, 'error');
        }
      }
    },
    validateCaptcha() {
      const recaptchaKey = process.env.RECAPTCHA_SITE_KEY;
      return new Promise((res) => {
        grecaptcha.enterprise.ready(() => {
          grecaptcha.enterprise.execute(recaptchaKey, { action: 'registration' }).then((token) => {
            this.$store.set('registration/reg1@recaptcha_token', token);
            return res(token);
          });
        });
      });
    },
    openPositiveCreditDataConsentModal() {
      this.showPositiveCreditDataConsentModal = true;
    },
    closePositiveCreditDataConsentModal() {
      this.showPositiveCreditDataConsentModal = false;
    },
    getWhatsappConsentLabel() {
      const label = `Autorizo receber mensagens do
        <img src="${this.whatsappIcon}" class="whatsapp-icon" alt="whatsapp icon">
        <strong>Whatsapp</strong> da Simplic sobre elegibilidade para empréstimos, status da solicitação,
        atualizações da conta e ofertas adicionais`;
      return label;
    },
  },
  validations() {
    const validators = {
      full_name: {
        required,
        moreThanOneWord,
      },
      email: {
        required,
        email,
        // uniqueEmail,
      },
      date_of_birth: {
        required,
        internationalDate,
        minimumAge,
      },
      cpf: {
        required,
        cpf,
        // uniqueCPF,
      },
      main_phone: {
        required,
        phoneNumberLength,
      },
      password: {
        required,
        passwordLength,
      },
      password_confirmation: {
        required,
        passwordLength,
        sameAsPassword: sameAs('password'),
      },
      wants_electronic_promotions: {},
      privacy_policy:              {
        privacyPolicyAgreed,
      },
      privacy_policy_text: {
        required: false,
      },
      whatsapp_consent_text: {
        required: false,
      },
      whatsapp_consent: {
        required: false,
      },
      positive_credit_data_consent_text: {
        required: false,
      },
      positive_credit_data_consent: {
        positiveCreditDataAgreed,
      },
      email_confirmation: {
        required,
        email,
        sameAsEmail: sameAs('email'),
      },
    };

    return validators;
  },
};
</script>
<style scoped>
form {
  padding: 1rem;
}

.form-group {
  color: #333333;
}
</style>
